export default __webpack_public_path__ + "static/media/ontraccr-login-logo.b1fa20f1.png";